import React from 'react';
import Select from 'react-select';
import clone from 'clone';
import { findIndex } from 'underscore';
import SidebarAction from '../../preview/action/sidebarAction';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import ReactToggle from 'react-toggle';
import { stringify } from '../../helper/helperFunction';

class SideBarPanel extends React.Component {
  constructor(props) {
    super(props);
    this.sidebarOptions = API.sidebar;
    this.handleSubmiCategory = this.handleSubmiCategory.bind(this);
    this.handleSidebarOptionChange = this.handleSidebarOptionChange.bind(this);
    this.state = {
      selectedSidebar: null,
    };
  }
  componentWillMount() {
    const allLayout = clone(this.props.allLayout);
    const uid = clone(this.props.uid);
    const index = findIndex(allLayout, { uid: uid.toString() });
    const self = this;
    if (index !== -1) {
      const indexOfSidebar = findIndex(allLayout[index].searchAttr, { viewType: 'sidebar' });
      if (indexOfSidebar !== -1) {
        const name = allLayout[index].searchAttr[indexOfSidebar].sidebarName;
        self.setState({ selectedSidebar: name });
      }
    }
  }
  handleSidebarOptionChange(selectedValue) {
    const value = (selectedValue === null ? null : selectedValue.value);
    this.setState({
      selectedSidebar: value,
    });
  }
  handleSubmiCategory() {
    SidebarAction.getSidebarWidget({
      name: this.state.selectedSidebar,
    });
    const allLayout = clone(this.props.allLayout);
    const uid = clone(this.props.uid);
    const index = findIndex(allLayout, { uid: uid.toString() });
    if (index !== -1) {
      const indexOfSidebar = findIndex(allLayout[index].searchAttr, { viewType: 'sidebar' });
      if (indexOfSidebar !== -1) {
        allLayout[index].searchAttr[indexOfSidebar].sidebarName = this.state.selectedSidebar;
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);

    }
  }

  render() {
    const sidebarArray = [];
    if (this.sidebarOptions !== undefined && this.sidebarOptions.length > 0) {
      this.sidebarOptions.forEach((sidebarOption) => {
        sidebarArray.push({
          'value': sidebarOption.name,
          'label': sidebarOption.name,
        });
      });
    }
    return (<div>
      <button className="layout-save-button" onClick={this.handleSubmiCategory}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
      <div className="reactive-tab-setting">
        <ul className="nav nav-tabs" role="tablist">
          <li role="presentation" className="active"><a href="#general" aria-controls="general" role="tab" data-toggle="tab">Settings</a></li>
        </ul>
        <div className="tab-content">
          <div role="tabpanel" className="tab-pane active" id="general">
            <p className="caption">Please select a sidbar</p>
            <Select onChange={this.handleSidebarOptionChange} options={sidebarArray} value={this.state.selectedSidebar} />
          </div>
        </div>
      </div>

    </div>);
  }
}

export default SideBarPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/search/sidebarPanel.js
 **/